var additionalFieldsPath, applyPlrUpdatesToEtdDoc, htmlToEscapedPlainText, joinPlrValues, mapPlrToPatientsPresentation, mapWhoIsThisFor, partContentPath, patientsPath, plrValue, set;

htmlToEscapedPlainText = require('base/lib/utils').htmlToEscapedPlainText;

set = require('lodash').set;

plrValue = function(field) {
  var _ref;
  return htmlToEscapedPlainText((_ref = field != null ? field.value : void 0) != null ? _ref : '');
};

joinPlrValues = function(fields) {
  return _.chain(fields).map(plrValue).map(function(value) {
    return value.trim();
  }).compact().value().join('\n\n');
};

mapWhoIsThisFor = function(whoIsThisFor) {
  var first, items, rest;
  items = _.isArray(whoIsThisFor) ? whoIsThisFor : [];
  first = _.first(items);
  rest = items.slice(1);
  return {
    content: plrValue(first),
    additionalFields: _.map(rest, function(item) {
      return {
        content: plrValue(item)
      };
    })
  };
};

mapPlrToPatientsPresentation = function(plr, isGps) {
  var who, whyPartId, whySectionId;
  if (isGps == null) {
    isGps = false;
  }
  who = mapWhoIsThisFor(plr != null ? plr.who_is_this_for : void 0);
  whySectionId = isGps ? 'whyThisGoodPracticeStatement' : 'whyThisRecommendation';
  whyPartId = isGps ? 'whyAGoodPracticeStatement' : 'whyThisRecommendation';
  return {
    whySectionId: whySectionId,
    whyPartId: whyPartId,
    whyContent: plrValue(plr != null ? plr.why_this_strength : void 0),
    benefitsAndHarms: joinPlrValues([plr != null ? plr.benefits : void 0, plr != null ? plr.harms : void 0]),
    additionalInformation: plrValue(plr != null ? plr.additional_information : void 0),
    whatYouCanDo: plrValue(plr != null ? plr.what_you_can_do : void 0),
    speakWithHCProfessional: plrValue(plr != null ? plr.talk_with_healthcare_provider : void 0),
    whoIsThisFor: who.content,
    whoAdditionalFields: who.additionalFields,
    recommendationContent: plrValue(plr != null ? plr.plain_language_recommendation : void 0)
  };
};

patientsPath = ['templateData', 'presentations', 'sections', 'patients'];

partContentPath = function(sectionId, partId) {
  return patientsPath.concat(['sections', sectionId, 'parts', partId, 'content']);
};

additionalFieldsPath = function(sectionId, partId) {
  return patientsPath.concat(['sections', sectionId, 'parts', partId, 'additionalFields']);
};

applyPlrUpdatesToEtdDoc = function(etdDoc, updates) {
  var additionalInformation, benefitsAndHarms, recommendationContent, speakWithHCProfessional, whatYouCanDo, whoAdditionalFields, whoIsThisFor, whyContent, whyPartId, whySectionId;
  additionalInformation = updates.additionalInformation, benefitsAndHarms = updates.benefitsAndHarms, recommendationContent = updates.recommendationContent, speakWithHCProfessional = updates.speakWithHCProfessional, whatYouCanDo = updates.whatYouCanDo, whoAdditionalFields = updates.whoAdditionalFields, whoIsThisFor = updates.whoIsThisFor, whyContent = updates.whyContent, whyPartId = updates.whyPartId, whySectionId = updates.whySectionId;
  set(etdDoc, partContentPath(whySectionId, whyPartId), whyContent);
  set(etdDoc, partContentPath(whySectionId, 'benefitsAndHarms'), benefitsAndHarms);
  set(etdDoc, partContentPath(whySectionId, 'additionalInformation'), additionalInformation);
  set(etdDoc, partContentPath('whatItMeansForYou', 'whatYouCanDo'), whatYouCanDo);
  set(etdDoc, partContentPath('whatItMeansForYou', 'speakWithHCProfessional'), speakWithHCProfessional);
  set(etdDoc, additionalFieldsPath('whatItMeansForYou', 'speakWithHCProfessional'), []);
  set(etdDoc, partContentPath('whoIsThisFor', 'whoIsThisFor'), whoIsThisFor);
  set(etdDoc, additionalFieldsPath('whoIsThisFor', 'whoIsThisFor'), whoAdditionalFields != null ? whoAdditionalFields : []);
  set(etdDoc, patientsPath.concat(['sections', 'recommendation', 'content']), recommendationContent);
  return etdDoc;
};

module.exports = {
  applyPlrUpdatesToEtdDoc: applyPlrUpdatesToEtdDoc,
  joinPlrValues: joinPlrValues,
  mapPlrToPatientsPresentation: mapPlrToPatientsPresentation,
  mapWhoIsThisFor: mapWhoIsThisFor,
  plrValue: plrValue
};
